import Universe from '@/components/universe/Universe';

const universe = () => {
  //To be used as an iframe
  return (
    <div className="w-screen h-screen">
      <Universe iframe />
    </div>
  );
};

export default universe;
